import { BookingAddressPicker } from '@components/Address/BookingAddressPicker';
import { NavioContactChatWidget } from '@components/BookingFlow/Common/NavioContactChatWidget';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { FlowBackButton } from '@components/Layouts/FlowBackButton';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { FixedBottomBarContainer, NoddiButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { useMobileBookingCustomer } from '../../../hooks/useMobileBookingCustomer';
import { useTrackProposalStep } from '../../../hooks/useTrackProposalStep';
import {
  useBookingProposalActions,
  useBookingProposalAddress,
  useBookingProposalSlug
} from '../../../stores/bookingProposalStore';

export const BookingProposalAddress = () => {
  const { setAddress } = useBookingProposalActions();
  const address = useBookingProposalAddress();
  const { userGroupId } = useMobileBookingCustomer();
  const navigate = useNavigate();
  const slug = useBookingProposalSlug();
  useTrackProposalStep('address');

  return (
    <ContentWrapperCustomerApp className='max-w-screen-md' title={t`Where do you need our help?`} hideBackButton>
      <BookingAddressPicker
        userGroupId={userGroupId}
        setSelectedAddress={(newAddress) => {
          // address is not in delivery area (or some error occurred), so we do nothing
          if (!newAddress) {
            return;
          }
          setAddress(newAddress);
        }}
      />
      <FixedBottomBarContainer>
        <div className='flex w-full items-center justify-between gap-2'>
          <div className='flex items-center gap-2'>
            <FlowBackButton />
            <NavioContactChatWidget />
          </div>
          <NoddiButton
            disabled={!address}
            endIcon='ArrowRight'
            // oxlint-disable-next-line typescript/no-misused-promises -- async onClick runs navigate(); React discards the returned promise, so a rejection is unhandled unless the body catches
            onClick={() => navigate(customerRoutes.bookingProposalTimeWindowPicker.getPath({ slug }))}
          >
            <Trans>Next</Trans>
          </NoddiButton>
        </div>
      </FixedBottomBarContainer>
    </ContentWrapperCustomerApp>
  );
};
